<template>
	<div v-if="exclamation && status" style="display: flex; align-items: center;">
		<div v-tooltip="toolTip" :class="classObj" class="exclamation">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>exclamation-thick</title>
				<path d="M10 3H14V14H10V3M10 21V17H14V21H10Z"/>
			</svg>
		</div>
		<div class="ellipsis" v-tooltip="status ? (status.title+': '+status.description) : false">{{
				status ? status.title : ''
			}}
		</div>
	</div>
	<span v-else v-tooltip="toolTip" :class="classObj"></span>

</template>

<script>
import moment from 'moment';

export default {
	name: "StatusDot",
	props: {
		info: {
			type: Object,
		},
		statusKey: {
			type: String,
		},
		exclamation: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		status() {
			let config = this.$store.state.deals.statusConfig;
			return this.info.row[this.statusKey] ? config.find(x => x.name === this.info.row[this.statusKey]) : null;
		},
		classObj() {
			return {
				'circle': !this.exclamation,
				'green': (this.status ? this.status.name === 'active' : false),
				'yellow': (this.status ? ['inactive', 'not_started'].includes(this.status.name) : false),
				'red': (this.status ? ['deactivated', 'ended', 'low_requests', 'blocking'].includes(this.status.name) : false),
			};
		},
		toolTip() {
			if (typeof this.status !== 'undefined' && this.status !== null) {
				let ret = this.status.parent.title;
				if (this.status.name === "inactive" || this.status.name === "active") {
					let date = this.info.row['last_impression'] ? moment(this.info.row['last_impression']) : null;
					ret += ': \n Letzter Umsatz: ' + (date ? date.format('DD.MM.YYYY') : 'vor 6 Monaten oder mehr');
				} else if (this.status.parent.title !== "Optimierung empfohlen") {
					ret += ': ' + this.status.title;
				}
				return ret;
			} else {
				return ''
			}
		}
	}
}

</script>

<style lang="scss" scoped>
.circle:before {
	content: ' \25CF';
	font-size: 2em;
}

.circle {
	color: #d3d9e5;
}

.exclamation {
	width: 1.6rem;
	position: relative;
	top: 2px
}

.exclamation svg {
	fill: #ee774b;
}

.ellipsis {
	width: 85px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.red {
	color: #da1e28;
}

.yellow {
	color: #f1b11b;
}

.green {
	color: #0ab13c;
}
</style>